import {BaseModel} from '@/models/base.model.js'

/**
 * User model
 */
export class User extends BaseModel {

  //Initials
  get initials() {
    return [this.firstName, this.lastName]
      .filter(Boolean)
      .map(n => n[0])
      .join('')
  }
}
